// extracted by mini-css-extract-plugin
module.exports = {"StatementPage":"index_StatementPage__2qrpe","headerCon":"index_headerCon__1wL2B","inputCons":"index_inputCons__1aBZz","btnWords":"index_btnWords__2LuIh"};